import React, { useEffect, useState } from "react";
import "./ReportPay.scss";
import { Button, Form, Row, Space, Spin, Table } from "antd";
import { InputFields } from "components/common";
import { ExcelSVG } from "assets";
import Icon from "assets/icons";
import dayjs from "dayjs";
import { columnsTable } from "./ReportPay.config";
import { payService, employeeService, medicalExaminationService } from "api";
import Notification from "components/common/notification/notification";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import { formatToCurrencyType } from "helper/common";
const { INPUT, SELECT, DATE, CODE, COMBO_BOX, AUTO_COMPLETE } = FIELD_TYPE;

const ReportPay = () => {
  // const onChangeSelect = async (value) => {
  //   // Assuming value parameter is the selected value of idNhomDichVu
  //   await getDvByListDm(value); // Call getDvByListDm function with the selected value
  // };
  const [selectedNhomDichVu, setSelectedNhomDichVu] = useState();

  // Sử dụng useEffect để log giá trị khi có sự thay đổi
  useEffect(() => {
    getDvByListDm(selectedNhomDichVu)
  //  console.log('Giá trị đã chọn trong ô idNhomDichVu:', selectedNhomDichVu);
  }, [selectedNhomDichVu]);
  // Thêm hàm onChange vào ô idNhomDichVu để cập nhật giá trị vào state
  const handleIdNhomDichVuChange = (value) => {
    setSelectedNhomDichVu(value);
  };
  const dataField: DataFormField[] = [
    {
      type: INPUT,
      label: "Mã bệnh nhân",
      name: "maBenhNhan",
      placeholder: "Nhập",
      css: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: INPUT,
      label: "Tên bệnh nhân",
      name: "tenBenhNhan",
      placeholder: "Nhập",
      css: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: SELECT,
      label: "Tên thu ngân",
      name: "tenThuNgans",
      mode: "multiple",
      placeholder: "Nhập",
      css: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: SELECT,
      label: "Trạng thái hoá đơn",
      name: "trangThai",
      placeholder: "Chọn",
      css: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
      options: [
        { value: 0, label: "Thanh toán" },
        { value: 1, label: "Hoàn phí" },
        { value: 2, label: "Huỷ thanh toán" },
      ],
    },
    {
      type: SELECT,
      label: "Hình thức thanh toán",
      name: "idHinhThucThanhToan",
      placeholder: "Chọn",
      css: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
      options: [
        { value: 0, label: "Tiền mặt" },
        { value: 1, label: "Chuyển khoản" },
        { value: 2, label: "Quẹt thẻ" },
      ],
    },
    {
      type: SELECT,
      label: "Đối tượng",
      name: "doiTuong",
      placeholder: "Chọn",
      css: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
      options: [
        { value: 0, label: "Tiền mặt" },
        { value: 1, label: "Chuyển khoản" },
        { value: 2, label: "Quẹt thẻ" },
      ],
    },
    {
      type: DATE,
      disableDate: false,
      optionsTime: { format: FORMAT_TIME.dateTime, showTime: true },
      label: "Thời gian từ",
      name: "start",
      css: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
      // optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
    },
    {
      type: DATE,
      disableDate: false,
      optionsTime: { format: FORMAT_TIME.dateTime, showTime: true },
      label: "Thời gian tới",
      name: "end",
      css: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
      // optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
    },

    {
      type: SELECT,
      label: "Nhóm dịch vụ",
      name: "idNhomDichVu",
      placeholder: "Chọn",
      css: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
      onChange: handleIdNhomDichVuChange,
    },

    {
      type: SELECT,
      label: "Loại dịch vụ",
      name: "type",
      placeholder: "Chọn",
      options: [
        { value: 0, label: "Ngoại trú" },
        { value: 1, label: "Nội trú" },
      ],
      css: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: SELECT,
      label: "Tên dịch vụ",
      name: "maDichVu",
      placeholder: "Chọn",
      // options: [
      //   {value: 0, label: "Tiền mặt"},
      //   {value: 1, label: "Chuyển khoản"},
      //   {value: 2, label: "Quẹt thẻ"},
      // ],
      //onChange:onChangeSelect,
      css: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
  ];
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(columnsTable);
  const [fields, setFields] = useState(dataField);
  const [form] = Form.useForm();
  const [totalPage, setTotalPage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [idNhomDV, setIdNhomDV] = useState();
  useEffect(() => {
    getListDm();
    fetchObjects();
    // getListThuNgan();
  }, []);
  const fetchObjects = async () => {
    try {
      const response = await medicalExaminationService.getListObjects();
      fields.find((e) => e.name == "doiTuong").options = response.data.map(
        (e) => {
          return { value: e.id, label: e.tenDoiTuong };
        }
      );
      setFields([...fields]);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục đối tượng");
    }
  };
  const getDvByListDm = async (selectedNhomDichVu) => {
    if(selectedNhomDichVu !== undefined || selectedNhomDichVu !== null) {
      try {
        const response = await payService.getDvByListDMDV(selectedNhomDichVu) || [];
        fields.find((e) => e.name == "maDichVu").options = response.map((e) => {
          return { value: e.id, label: e.tenDichVu };
        });
        setFields([...fields]);
      } catch (error) {
       // console.log("error", error);
        Notification("error", "Đã có lỗi xảy ra khi lấy danh mục dịch vụ");
      }
    }
  };
  useEffect(() => {
    form.setFieldValue("tenThuNgans", []); // Set giá trị mặc định là một mảng rỗng cho trường 'tenThuNgans'
  }, []);
  const getListDm = async () => {
    try {
      const response = (await payService.getListDMDV()) || [];
      // console.log('danh mục dv', response);
      fields.find((e) => e.name == "idNhomDichVu").options = response.map(
        (e) => {
          return { value: e.id, label: e.tenNhomDichVu };
        }
      );
      setFields([...fields]);
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh mục dịch vụ");
    }
  };

  // const getListThuNgan = async () => {
  //   try {
  //     const response = (await payService.getListNv()) || [];
  //     fields.find((e) => e.name == "tenThuNgan").options = response.map(
  //       (e) => {
  //         return {
  //           value: e.id,
  //           label: e.tenNhanVien
  //         }
  //       }
  //     );
  //     setFields([...fields]);
  //   } catch (error) {
  //     Notification("error", "Đã có lỗi xảy ra khi lấy danh sách nhân viên thu ngân");
  //   }
  // }

  useEffect(() => {
    getListEmployee();
  }, []);
  // const getListEmployee = async () => {
  //   try {
  //     const response = (await employeeService.searchEmployee({
  //       page: 1,
  //       limit: 1000,
  //     })) || [];

  //     const mappedOptions = response.items.map((e) => {
  //       let label = e.hoTen;
  //       if (e.idVaiTro.includes(1)) {
  //         label = `BS. ${label}`;
  //       }
  //       return { value: e.hoTen, label };
  //     });

  //     fields.find((e) => e.name === "tenThuNgans").options = mappedOptions;

  //     setFields([...dataField]);
  //   } catch (error) {
  //     console.log('ERROR', error);
  //   }
  // }

  const getListEmployee = async () => {
    try {
      const response =
        (await employeeService.searchEmployee({
          page: 1,
          limit: 1000,
        })) || [];
      fields.find((e) => e.name == "tenThuNgans").options = response.items.map(
        (e) => {
          return { value: e.hoTen, label: e.hoTen };
        }
      );
      setFields([...dataField]);
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const handleOnFinish = () => {
    const data = form.getFieldsValue();
    if (Array.isArray(data.tenThuNgans)) {
      data.tenThuNgans = data.tenThuNgans.join(","); // Chuyển thành chuỗi ngăn cách bằng dấu phẩy
    }
    const dataParams = {
      ...data,
      start: dayjs(data.start).format(FORMAT_TIME.dateTimeH),
      end: dayjs(data.end).format(FORMAT_TIME.dateTimeH),
    };
    if (
      !dataParams.start ||
      !dataParams.end ||
      dataParams.start == "Invalid Date" ||
      dataParams.end == "Invalid Date"
    ) {
      Notification("warning", "Vui lòng chọn ngày");
      return;
    }
    getData(dataParams);
  };

  const getData = async (data) => {
    setLoading(true);
    try {
      const response = await payService
        .getDataReportPayNew(data)
        .then((res) => {
          // console.log("res report", res);
          setData(res.data);
          setLoading(false);
          Notification("success", "Lấy thông tin báo cáo thành công");
        });
      // const response = await payService.getDataReportPayNew(data).then((res) => {
      //   // console.log("res report", res);
      //   setData(res.data);
      //   Notification("success", "Lấy thông tin báo cáo thành công");
      // });
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi lấy thông tin báo cáo");
    }
  };

  const addClass = (arr, idx) => {
    if (idx + 1 == arr.length) {
      return "";
    } else {
      return "border-bottom-cell";
    }
  };

  columnsTable.map((col) => {
    if (col.dataIndex == "hinhThucThanhToan") {
      col.render = (value, record: any, index) => {
        return (
          <>
            {record.hoanThanhThanhToanDtos?.map((value, index) => (
              <div
                className={addClass(record.hoanThanhThanhToanDtos, index)}
                key={index}
              >
                {value?.hinhThucThanhToan}
              </div>
            ))}
          </>
        );
      };
    }
    if (col.dataIndex == "soTienThucThu") {
      col.render = (value, record: any, index) => {
        return (
          <>
            {record.hoanThanhThanhToanDtos?.map((value, index) => (
              <div
                className={addClass(record.hoanThanhThanhToanDtos, index)}
                key={index}
              >
                {formatToCurrencyType(value?.soTienGiaoDich)}
              </div>
            ))}
          </>
        );
      };
    }
    if (col.dataIndex == "soPhieuThu") {
      col.render = (value, record: any, index) => {
        return (
          <>
            {record.hoanThanhThanhToanDtos?.map((value, index) => (
              <div
                className={addClass(record.hoanThanhThanhToanDtos, index)}
                key={index}
              >
                {value?.soPhieuThu}
              </div>
            ))}
          </>
        );
      };
    }
  });

  const handelOnExport = async () => {
    setLoadingPage(true);
    const data = form.getFieldsValue();
    if (Array.isArray(data.tenThuNgans)) {
      data.tenThuNgans = data.tenThuNgans.join(","); // Chuyển thành chuỗi ngăn cách bằng dấu phẩy
    }
    const dataParams = {
      ...data,
      start: dayjs(data.start).format(FORMAT_TIME.dateTimeH),
      end: dayjs(data.end).format(FORMAT_TIME.dateTimeH),
    };
    if (
      !dataParams.start ||
      !dataParams.end ||
      dataParams.start == "Invalid Date" ||
      dataParams.end == "Invalid Date"
    ) {
      Notification("warning", "Vui lòng chọn ngày");
      return;
    }
    // console.log('data config export', newData);
    try {
      const response = await payService
        .getExportReportPayNew(dataParams)
        .then((res) => {
          // console.log("res export", res);
          var link = document.createElement("a");
          const url = window.URL.createObjectURL(res.data);
          link.href = url;
          link.download = `Báo cáo thanh toán.xlsx`;
          link.click();
          setLoadingPage(false);
          Notification("success", "Đã xuất file báo cáo");
        });
    } catch (error) {
      setLoadingPage(false);
      Notification("error", "Đã có lỗi xảy ra khi xuất file báo cáo");
    }
  };

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const paginationConfig = {
    current: currentPage,
    total: totalPage,
    showSizeChanger: true,
    pageSize: pageSize,
    onChange: handlePaginationChange,
  };

  useEffect(() => {
    const todayStartWithTime = dayjs()
      .set("hour", 0)
      .set("minute", 0)
      .set("second", 0);
    const todayEndWithTime = dayjs()
      .set("hour", 23)
      .set("minute", 59)
      .set("second", 59);
    form.setFieldValue("start", todayStartWithTime);
    form.setFieldValue("end", todayEndWithTime);
  }, []);

  return (
    <Spin spinning={loadingPage}>
      <div className="report-pay-tab-container">
        <div className="container">
          <Form form={form} onFinish={handleOnFinish}>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row gutter={[16, 16]}>
                <InputFields data={fields} />
              </Row>
              <Row justify={"end"} style={{ marginTop: "16px" }}>
                <Space>
                  <Button
                    icon={<ExcelSVG />}
                    className="custom-btn"
                    onClick={handelOnExport}
                  >
                    Xuất báo cáo
                  </Button>
                  <Button
                    icon={<Icon.eye />}
                    className="btn-sub"
                    htmlType="submit"
                  >
                    Xem thông tin
                  </Button>
                </Space>
              </Row>
            </Space>
          </Form>
        </div>
        <div className="container">
          <Table
            bordered
            pagination={paginationConfig}
            dataSource={data}
            loading={loading}
            columns={columns}
            scroll={{ x: 2500 }}
          />
        </div>
      </div>
    </Spin>
  );
};

export default ReportPay;
